jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS
        var wl = [];
        wl.init = false;
        wl.lastAction = false;
        var axw = null;

        $(window).on('load', function(){
            wishlistInit();
        });

        setTimeout(function(){
            if ( wl.init == false) {
                wishlistInit();
            }
        }, 3000);

        function wishlistInit(){
            wl.init = true;
            if ($('#sc-wl').length>0) {
                $('#sc-wl').removeAttr('style');

                $('body').on('click', '.whl', function(e){
                    e.preventDefault();
                    var pid = $(this).attr('data-pid');
                    if (pid != undefined && pid != '') {
                        wl.pid = pid;
                        initAddToWl();
                    }
                });

                $('body').on('click', '.close-wl', function(){
                    wlToggle();
                });
                $('body').on('click', '.sc-wl-list-overlay', function(){
                    wlToggle();
                });
                $('body').on('click', '.wl-action.add-to', function(e){
                    e.preventDefault();
                    var wlId = $(this).attr('data-id');
                    if (wlId != undefined && wlId != '') {
                        addToWL(wlId);
                    }
                });
                $('body').on('click', '.wl-action.remove-from', function(e){
                    e.preventDefault();
                    var wlId = $(this).attr('data-id'),
                        pr_key = $(this).attr('data-key');
                    if (wlId != undefined && wlId != '' && pr_key != undefined && pr_key != '') {
                        removeFromWL(wlId, pr_key);
                    }
                });

                $('body').on('click', '.wl-action.create-new', function(e){
                    e.preventDefault();
                    var newWlForm = '';
                    newWlForm = newWlForm + '<form class="new-wl" id="new-wl" method="post" action="_self" style="display: none;">';
                    newWlForm = newWlForm + '<input type="text" value="" name="wlname" placeholder="Enter Name">';
                    newWlForm = newWlForm + '<button class="button" type="submit">Create</button>';
                    newWlForm = newWlForm + '</form>';
                    $('.new-wl').remove();
                    $(this).parent().append(newWlForm);
                    $('#new-wl').slideToggle();
                });

                $('body').on('submit', '.new-wl', function(e){
                    e.preventDefault();
                    var name = $('input[name=wlname]').val();
                    if (name != '' && name != undefined) {
                        addNewWL(name);
                    }
                });
                getWLists();
            }
        }

        function initAddToWl() {
            wlToggle();
            $( document.body ).trigger( 'wl_updated' );
        }

        $( document.body ).on( 'wl_got_lists', function(){
            renderWishList();
        });

        function renderWishList() {
            var html = '<ul class="wl-actions">';
            html = html + '<li>';
            html = html + '<div class="wl-action create-new"><figure class="new"></figure>';
            html = html + '<h5 class="action-text">Create new wishlist</h5>';
            html = html + '</div></li>';
            html = html + '';
            html = html + '';
            html = html + '';
            if (wl.lists != undefined && wl.lists != '-1') {
                $.each(wl.lists, function(k, v) {
                    var InWlList = false,
                        key = '';
                    $.each(v.items, function(id, dt){
                        if (wl.pid == id) {
                            InWlList = true;
                            key = dt.product_key;
                        }
                    });
                    if (InWlList) {
                        html = html + '<li>';
                        html = html + '<div class="wl-action remove-from" data-key="'+key+'" data-id="'+v.id+'" title="Add to '+v.title+'"><figure class="wbg" style="background-image: url('+v.image+')"></figure>';
                        html = html + '<h5 class="action-text">'+v.title+' <a href="'+v.link+'" title="'+v.title+'">('+v.total_items+' items)</a> <br/><span>Remove from list</span></h5>';
                        html = html + '</div></li>';
                    }
                    else {
                        html = html + '<li>';
                        html = html + '<div class="wl-action add-to" data-id="'+v.id+'" title="Add to '+v.title+'"><figure class="wbg" style="background-image: url('+v.image+')"></figure>';
                        html = html + '<h5 class="action-text">'+v.title+' <a href="'+v.link+'" title="'+v.title+'">('+v.total_items+' items)</a></h5>';
                        html = html + '</div></li>';
                    }

                });
            }
            $('.sc-wl-content').html(html);
            $( document.body ).trigger( 'wl_render_done' );
        }

        $( document.body ).on( 'wl_updated', function(){
            getWLists();
            if (wl.lastAction != false) {
                if (wl.lastAction == 'add') {
                    $('.whl[data-pid='+wl.pid+']').addClass('in-whl');
                }
                else if (wl.lastAction == 'remove') {
                    $('.whl[data-pid='+wl.pid+']').removeClass('in-whl');
                }
            }
        });

        $( document.body ).on( 'wl_created', function(){
            if (wl.new_list_id != undefined && wl.new_list_id != '') {
                var wlId = wl.new_list_id;
                addToWL(wlId);
            }
        });

        function addToWL(id){
            if (wl.pid != undefined && id != undefined) {
                wlSpinner();
                if ( axw != null ) {
                    axw.abort();
                    axw = null;
                }
                var qty = $('input[name="qty['+wl.pid+']"]').val();
                if (qty == undefined) {
                    qty = 1;
                }
                axw = $.ajax({
                    url: ajax_url,
                    timeout: 12000,
                    type: 'POST',
                    cache: false,
                    data: ({
                        action: 'sc_add_to_wishlist',
                        id: id,
                        product_id: wl.pid,
                        qty: qty
                    }),
                    beforeSend: function() {
                        wl.lastAction = 'add';
                    },
                    success: function(data) {
                        $( document.body ).trigger( 'wl_updated' );
                    },
                    error: function( jqXHR, textStatus, errorThrown ) {
                        console.log( 'The following error occured: ' + textStatus, errorThrown );
                    },
                    complete: function( jqXHR, textStatus ) {
                    }
                });
            }
        }

        function removeFromWL(id, pr_key){
            if (id != undefined && pr_key != undefined) {
                wlSpinner();
                if ( axw != null ) {
                    axw.abort();
                    axw = null;
                }
                axw = $.ajax({
                    url: ajax_url,
                    timeout: 12000,
                    type: 'POST',
                    cache: false,
                    data: ({
                        action: 'sc_delete_from_wishlist',
                        id: id,
                        product_key: pr_key
                    }),
                    beforeSend: function() {
                        wl.lastAction = 'remove';
                    },
                    success: function(data) {
                        $( document.body ).trigger( 'wl_updated' );
                    },
                    error: function( jqXHR, textStatus, errorThrown ) {
                        console.log( 'The following error occured: ' + textStatus, errorThrown );
                    },
                    complete: function( jqXHR, textStatus ) {
                    }
                });
            }
        }

        function addNewWL(name){
            if (name != undefined && name != '') {
                wlSpinner();
                if ( axw != null ) {
                    axw.abort();
                    axw = null;
                }
                axw = $.ajax({
                    url: ajax_url,
                    timeout: 12000,
                    type: 'POST',
                    cache: false,
                    data: ({
                        action: 'sc_create_wishlist',
                        title: name,
                    }),
                    beforeSend: function() {
                    },
                    success: function(data) {
                        wl.new_list_id = data;
                        $( document.body ).trigger( 'wl_created' );
                    },
                    error: function( jqXHR, textStatus, errorThrown ) {
                        console.log( 'The following error occured: ' + textStatus, errorThrown );
                    },
                    complete: function( jqXHR, textStatus ) {
                    }
                });
            }
        }

        function wlToggle() {
            $('#sc-wl').toggleClass('active');
        }

        function wlSpinner(){
            $('.sc-wl-content .spinner').remove();
            $('.sc-wl-content').append('<div class="spinner"><div class="lds-dual-ring"></div></div>');
        }

        function getWLists(){
            if ( axw != null ) {
                axw.abort();
                axw = null;
            }
            axw = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: 'POST',
                cache: false,
                data: ({
                    action: 'sc_get_all_wishlists',
                }),
                beforeSend: function() {
                },
                success: function(data) {
                    var wlists = decodeJSON(data)
                    wl.lists = wlists;
                    $( document.body ).trigger( 'wl_got_lists' );
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        //Document Ready ENDS
    });
})(jQuery);